// import React from 'react';
// import './HomeShowcaseSection.css';
// import img1 from '../Images/R3.png';
// import img2 from '../Images/R4.png';
// import img3 from '../Images/R5.png';
// import { FaGift, FaTag, FaCrown, FaGem, FaStar } from 'react-icons/fa';

// const HomeShowcaseSection = () => {
//   return (
//     <section className="home-showcase-section">
//       {/* Left Large Image */}
//       <div className="left-large-image">
//         <img src={img1} alt="Diamond Ring" />
//         <div className="top-right-logo">SPINELLE ✦</div>
//         <div className="offer-badge">
//           <FaTag /> Festive Offer 20% OFF
//         </div>
//         <div className="highlight-text">
//           <FaCrown /> Solitaire Elegance
//         </div>
//       </div>

//       {/* Right Stacked Images */}
//       <div className="right-stacked-images">
//         <div className="stacked-image">
//           <img src={img2} alt="Rose Gold Rings" />
//           <div className="gift-icon">
//             <FaGift /> Gift Pack Available
//           </div>
//           <div className="overlay-text-bottom">
//             <FaGem /> Rose Gold Collection
//           </div>
//         </div>
//         <div className="stacked-image">
//           <img src={img3} alt="Gemstone Jewelry" />
//           <div className="overlay-text-bottom">
//             <FaStar /> Vibrant Gemstones
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HomeShowcaseSection;


import React, { useEffect, useState } from 'react';
import './HomeShowcaseSection.css';
import { FaGift, FaTag, FaCrown, FaGem, FaStar } from 'react-icons/fa';

const HomeShowcaseSection = () => {
  const [showcaseData, setShowcaseData] = useState(null);

  useEffect(() => {
    // Fetch the data from the API
    fetch('https://spinelleapi.emedha.in/admin/advertise/get/advertise')
      .then((response) => response.json())
      .then((data) => {
        // Filter the 'Showcase Cards' type from the fetched data
        const showcase = data.data.find((item) => item.type === 'Showcase Cards');
        setShowcaseData(showcase);  // Set the fetched data to state
      })
      .catch((error) => {
        console.error('Error fetching the data:', error);
      });
  }, []);

  if (!showcaseData) {
    // Optionally, show a loading spinner or placeholder if data is not loaded
    return <div>Loading...</div>;
  }

  return (
    <section className="home-showcase-section">
      {/* Left Large Image */}
      <div className="left-large-image">
        {showcaseData.left_large && (
          <img src={showcaseData.left_large} alt="Diamond Ring" />
        )}
        <div className="top-right-logo">SPINELLE ✦</div>
        <div className="offer-badge">
          <FaTag /> Festive Offer 20% OFF
        </div>
        <div className="highlight-text">
          <FaCrown /> Solitaire Elegance
        </div>
      </div>

      {/* Right Stacked Images */}
      <div className="right-stacked-images">
        {showcaseData.right_top && (
          <div className="stacked-image">
            <img src={showcaseData.right_top} alt="Rose Gold Rings" />
            <div className="gift-icon">
              <FaGift /> Gift Pack Available
            </div>
            <div className="overlay-text-bottom">
              <FaGem /> Rose Gold Collection
            </div>
          </div>
        )}
        {showcaseData.right_bottom && (
          <div className="stacked-image">
            <img src={showcaseData.right_bottom} alt="Gemstone Jewelry" />
            <div className="overlay-text-bottom">
              <FaStar /> Vibrant Gemstones
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeShowcaseSection;
